import {Formik} from "formik";
import {useMemo, useState} from "react";
import * as Yup from "yup";
import {KeHoachProvider} from "../../contexts/keHoach";
import FormKeHoach from "./components/FormKeHoach";

interface Props {
  warehouseId?: number;
  className?: any;
}

export const KeHoach = (props: Props) => {
  const {warehouseId, className} = props;
  const [dsYeuCau, setDsYeuCau] = useState([]);
  const [detailPhieuYeuCau, setDetailPhieuYeuCau] = useState({});

  let validationSchema = Yup.object({});
  const handleFormSubmit = (values: any) => {
  }

  const contextValue = useMemo(() => ({
    dsYeuCau: dsYeuCau,
    setDsYeuCau: setDsYeuCau,
    detailPhieuYeuCau,
    setDetailPhieuYeuCau,
  }), [dsYeuCau, detailPhieuYeuCau]);
  return (
    <Formik<any>
      initialValues={{}}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
    >
      <KeHoachProvider value={contextValue}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1">
              <FormKeHoach
                className={className}
                warehouseId={warehouseId}
              />
            </div>
          </div>
        </div>

      </KeHoachProvider>
    </Formik>

  )
}

export default KeHoach;
